import { CustomTooltipContentProps } from '../../../common';

export const emaExplanationInfo: CustomTooltipContentProps = {
  title: '⚡️ Subjective energy adjustment',
  description:
    'Wearables provide useful objective signals, but they do not always match how you feel. Your self-reported energy is important too. When you report how energized you feel, we make a short-term adjustment to your energy curve.',
  learnMoreLink:
    'https://demind-inc.notion.site/Reporting-Your-Subjective-Feelings-26f7c97113e68029a6a6ed5d233b6468',
  referenceLinkList: [
    {
      title:
        'Quantifying Energy and Fatigue: Classification and Assessment of Energy and Fatigue Using Subjective, Objective, and Mixed Methods towards Health and Quality of Life',
      url: 'https://link.springer.com/chapter/10.1007/978-3-030-94212-0_4',
    },
    {
      title:
        'micro-Stress EMA: A Passive Sensing Framework for Detecting in-the-wild Stress in Pregnant Mothers',
      url: 'https://www.ncbi.nlm.nih.gov/pmc/articles/PMC7236910/',
    },
  ],
};
